const TitleTypes = {
    H1: 'h1',
    H1_UPPERCASE: 'h1_uppercase',
    H1_ITALIC: 'h1_italic',
    H1_ITALIC_UPPERCASE: 'h1_italic_uppercase',
    H2: 'h2',
    H2_ITALIC: 'h2_italic',
    H3_ITALIC: 'h3_italic',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    SPAN: 'span',
    H1_LINK: 'h1_link',
    H1_LINK_ITALIC: 'h1_link_italic',
    H1_LINK_ITALIC_UPPERCASE: 'h1_link_italic_uppercase',
    H2_LINK: 'h2link',
    H2_LINK_ITALIC: 'h2_link_italic',
    H2_LINK_ITALIC_UPPERCASE: 'h2_link_italic_uppercase',
    H3_LINK: 'h3link',
    H4_LINK: 'h4link',
} as const;

export type TitleType = typeof TitleTypes[keyof typeof TitleTypes];

/*
 * TODO: Migrate whole Title component to TS and split title
 * types (styles) and html heading tags (used in <Title as={HERE} />).
 * Currently, both are combined in the TitleTypes object which doesn't
 * make too much sense.
 */

// @ts-expect-error
export function htmlTagFromTitleSize(textSize) {
    // @ts-expect-error
    return TitleTypes[textSize.toUpperCase()];
}

export default TitleTypes;
